import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ds-lib-login-button',
  templateUrl: './ds-lib-login-button.component.html',
  styleUrls: ['./ds-lib-login-button.component.css'],
})
export class DsLibLoginButtonComponent {
  /**
   * The button title
   */
  @Input() title: string;

  /**
   * The disabled state
   */
  @Input() disabled: boolean;

  /**
   * The disabled state
   */
  @Input() showSpinner: boolean;

  /**
   * The login button emmiter event.
   */
  @Output() loginClick = new EventEmitter();

  /**
   * The spinner mode
   */
  public spinnerMode = 'indeterminate';

  /**
   * Emit the login event.
   */
  onloginClick() {
    this.loginClick.emit();
  }
}
